import { render, staticRenderFns } from "./RegisterValidateKomship.vue?vue&type=template&id=13fece6d&"
import script from "./RegisterValidateKomship.vue?vue&type=script&lang=js&"
export * from "./RegisterValidateKomship.vue?vue&type=script&lang=js&"
import style0 from "./RegisterValidateKomship.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports